import React from 'react';
import banner from '../../../Assets/carousel.svg';
import comment from '../../../Assets/comment-icon.svg';
import insta from '../../../Assets/insta-icon.svg';
import './Banner.css'

const Banner = () => {

    return (
        <div className='container banner-bg' id='banner'>
            <div className='banner-area d-flex align-items-center'>
                <div className="row d-flex align-items-center justify-content-between h-100 py-md-5 ps-md-5">
                    <div className="col-md-5 col-12 d-flex align-items-center carousel-btn-area">
                        <div id="carouselExampleCaptions" className="carousel slide carousel-fade text-dark" data-bs-ride="carousel">
                            <div className="carousel-indicators d-flex align-items-center justify-content-between theme-font w-100">
                                <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active text d-flex align-items-center justify-content-evenly " aria-current="true" aria-label="Slide 1"> <span className='span-yellow w-25'>1 </span> <span className='span-black w-75'>Business  Vision</span></button>
                                <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" className='text d-flex align-items-center justify-content-evenly' aria-label="Slide 2"><span className='span-yellow w-25'>2 </span> <span className='span-black w-75'>Amazing Team</span></button>
                                <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" className='text d-flex align-items-center justify-content-evenly' aria-label="Slide 3"><span className='span-yellow w-25'>3 </span> <span className='span-black w-75'>Quality Talent</span></button>
                            </div>

                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <h1 className="hero-heading">We  bring  digital  presence to  your  business  that trigger a  fruitful  growth  in  your business.</h1>
                                </div>
                                <div className="carousel-item">
                                    <h1 className="hero-heading">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium dicta, doloribus?</h1>
                                </div>
                                <div className="carousel-item">
                                    <h1 className="hero-heading">Obcaecati consectetur dolor a sunt maiores placeat, debitis eos, Minima, dolorum!</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 col-12 d-flex justify-content-end pb-5 carousel-img-area">
                        <img className='carousel-img' src={banner} alt="" />
                        <div className="d-flex flex-column justify-content-end align-items-end mt-5 ">
                        <div className='pb-4'>
                            <img className='w-100' src={insta} alt="" />
                        </div>
                        <div > <img className='w-100' src={comment} alt="" /></div>
                    </div>
                    </div>
                   
                </div>
            </div>
        </div >
    );
};

export default Banner;